// extracted by mini-css-extract-plugin
module.exports = {"rootContainer":"GalleryAccordion_rootContainer__mg6Tv","columnHeaderActions":"GalleryAccordion_columnHeaderActions__1mroH","content":"GalleryAccordion_content__1WxVD"};